// Utilitário para verificar se uma seção tem pelo menos um item implementado
export const sectionHasImplementedNodes = (items, implementedNodes) => {
    return items.some(item => implementedNodes.includes(item.nodeType || item.title));
};

// Utilitário para filtrar apenas itens implementados (usado quando não em modo dev)
export const getImplementedItems = (items, implementedNodes) => {
    return items.filter(item => implementedNodes.includes(item.nodeType || item.title));
};

// Lista dos nós implementados (deve ser a mesma do NodeDrag.jsx)
export const implementedNodes = [
    "Atribuir",
    "Fundo",
    "Visível",
    "Decidir", 
    "Esperar",
    "Fim",
    "Fluxograma",
    "Inicio",
    "Interagir Avatar",
    "Posicionar",
    "Ler",
    "Mostrar",
    "Repetir",
    "Virar",
    "Igual a",
    "Diferente",
    "Maior que",
    "Menor que",
    "Maior ou igual a",
    "Menor ou igual a",
    "Subtração",
    "Soma",
    "Multiplicação",
    "Divisão",
    "Potenciação",
    "Radiciação",
    "Conjunção/Interseção",
    "Disjunção inclusiva/União",
    "Negação/complementação",
    "Disjunção exclusiva"
];